import { render, staticRenderFns } from "./FloatingDownloadQr.vue?vue&type=template&id=c13a078e&scoped=true"
import script from "./FloatingDownloadQr.vue?vue&type=script&lang=js"
export * from "./FloatingDownloadQr.vue?vue&type=script&lang=js"
import style0 from "./FloatingDownloadQr.vue?vue&type=style&index=0&id=c13a078e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13a078e",
  null
  
)

export default component.exports